/* eslint-disable no-console */
if (!window.bridge) {
  document.location = 'https://likezoid.com/';
}

import { store } from './store';
import axios from 'axios';

const bridge = window.bridge.native;
const igAPI = bridge.InstagramAPI;


const BridgeAPI = {
  async getLikezoidVersion() {
    // return '1.0.85';
    return bridge.LikezoidVersion(); 
  },
  async setTutorialDone() { return bridge.Storage.setTutorialDone(); },
  async getTutorialDone() { return bridge.Storage.getTutorialDone(); },
  async request (axiosConfig) { return window.bridge.request(axiosConfig); },
  async minimizeWindow () { bridge.minimizeWindow(); },
  async closeWindow () { bridge.closeWindow(); },
  async getInstallId () { return bridge.Storage.installId() },
  async getAllAccounts () {
    console.log('getallAccounts called');
    const out = bridge.Storage.getAccounts();
    return out;
  },
  async removeAccount (userId) { return bridge.Storage.softRemoveAccount(userId); },
  async getLoggedInAccounts () { return bridge.Storage.getAllLoggedInAccounts(); },
  async setAccountNeedsLogin (userId) { return bridge.Storage.setAccountNeedsLogin(userId); },
  async fetchUser (username) { return igAPI.fetchUser(username); },
  async openLink (url) { return bridge.OpenLink({ url: url }); },
  async sendIdentify () { return bridge.Socket.sendIdentify(); },
  
  // get the cookies for the user and fire it off
  // Also acts as a "check if logged in" endpoint. :)
  async fetchEditProfile (username) {
    let accounts = await this.getLoggedInAccounts();
    let account = accounts.find(acc => acc.profile.username === username);
    if (account) {
      let cookies = account.cookies;
      console.log(cookies)
      return igAPI.fetchEditProfile(cookies).then(res => {
        console.log(res);
        if (res.data) {
          if (typeof (res.data) === 'string' && res.data.includes('Sign in to')) {
            this.setAccountNeedsLogin(account.user_id);
            store.dispatch('loadAccounts'); // Dispatched vuex event to reload the accounts from config
            return false;
          } else {
            return res.data;
          }
        }
        return false;
      });
    }
    return false;
  }
};

class InstagramAPI {
  // Old hash - new one works!
  // static GetUserMediaByIdHash = 'f2405b236d85e8296cf30347c9f08c2a';
  static GetUserMediaByIdHash = 'c6809c9c025875ac6f02619eae97a80e';
  static GetUserMediaByIdHashAlt = '69cba40317214236af40e7efa697781d';
  // Alternate: 003056d32c2554def87228bc3fd9668a


  /**
   * Build the cookie string locally for this account
   * @param {Object} account Account object
   */
  static buildCookieString (account) {
    let cookieString = '';
    if (account) {
      let cookies = account.cookies;
      if (cookies && cookies.length) {
        cookies.forEach(cookie => {
          if (cookie.name && cookie.value) {
            cookieString = `${cookieString} ${cookie.name}=${cookie.value};`
          }
        })
      }
    }
    return cookieString;
  }
  
  /**
   * Make a request
   * @param {Object} conf AxiosConfig object (bridged)
   */
  static async makeRequest (conf) {
    let payload = JSON.parse(JSON.stringify(conf));
    console.log(payload);
    return window.bridge.request(payload); 
  }

  /**
   * Fetch an Instagram user
   * @param {String} username Instagram username
   */
  static async fetchUser (username) {
    console.log('Fetching user:', username); // eslint-disable-line
    let request = {
      method: 'GET',
      url: `https://instagram.com/${username}?__a=1`,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'upgrade-insecure-requests': '1',
        'accept': '*/*',
        'accept-language': 'en-US,en;q=0.9,de;q=0.8',
        'cache-control': 'no-cache',
        'pragma': 'no-cache',
      },
    };
    // return this.makeRequest(request);
    return axios.request(request, {
      responseType: 'json',
      withCredentials: false,
    });
  }

  static async remoteImageToBase64(url) {
    console.log('trying to download image', `${url}LOLOLOL`);
    let request = {
      method: 'GET',
      url: url,
      headers: {
        'upgrade-insecure-requests': '1',
        'accept': 'text/html,application/xhtml+xml,application/xml;q=0.9,image/avif,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3;q=0.9',
        'accept-language': 'en-US,en;q=0.9,de;q=0.8',
        'cache-control': 'no-cache',
        'pragma': 'no-cache',
        'referer': '',
      },
      maxRedirects: 2,
      responseType: 'arraybuffer',
      withCredentials: false,
    };
    const response = await this.makeRequest(request);
    let image = btoa(
      new Uint8Array(response.data)
        .reduce((data, byte) => data + String.fromCharCode(byte), '')
    );
    const out = `data:${response.headers['content-type'].toLowerCase()};base64,${image}`;
    return out;
  }

  static async fetchUserMedia (userId, offset, limit = 12, any = false) {
    console.log('Fetching media:', userId); // eslint-disable-line
    //
    // 1. Get account where id/pk == userId
    let check1 = await BridgeAPI.getLoggedInAccounts();
    let check = check1.filter(account => {
      return account.user_id === `${userId}` && account.removed === false;
    });

    if (!check.length) {
      if (any === true) {
        throw new Error('Unable to find an active account to fetch posts with.');
      }
      return this.fetchUserMedia (userId, offset, limit, true);
    }

    const account = check[0];
    const cookieString = this.buildCookieString(account);

    let variables = {
      id: userId,
      first: limit
    }

    if (offset) {
      variables.after = offset;
    }

    let request = {
      method: 'GET',
      url: 'https://www.instagram.com/graphql/query/',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'upgrade-insecure-requests': '1',
        'accept': '*/*',
        'accept-language': 'en-US,en;q=0.9,de;q=0.8',
        'cache-control': 'no-cache',
        'pragma': 'no-cache',
        'cookie': cookieString,
        'User-Agent': 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/93.0.4577.82 Safari/537.36'
      },
      params: {
        query_hash: this.GetUserMediaByIdHashAlt,
        variables: JSON.stringify(variables),
      },
    }

    return this.makeRequest({
      ...request,
      withCredentials: true,
    });
  }
}



export {
  BridgeAPI,
  InstagramAPI
}